import React, { useEffect, useState } from "react";
import { useUserContext } from "../../context/user.context";
import coffe from "../../assets/img/backgrounds/coffe.png";
import vending from "../../assets/img/backgrounds/vending.png";
import boostbar from "../../assets/img/backgrounds/boostbar.png";

export const ShowImage = ({ imgClass }) => {
  const { selectedMerchant } = useUserContext();

  const [showImage, setShowImage] = useState("");

  const coffeMerchants = ["Selecta"];
  const boostbarName = ["Boostbar", "Boostbar PayOnly", "aeguana"];

  useEffect(() => {
    if (coffeMerchants.includes(selectedMerchant)) {
      setShowImage(coffe);
    } else if (boostbarName.includes(selectedMerchant)) {
      setShowImage(boostbar);
    } else {
      setShowImage(vending);
    }
  }, [selectedMerchant]);

  return <img src={showImage} alt="error" className={imgClass} style={{ display: "block", filter: "blur(1px)", opacity: 0.5 }} />;
};
